<script setup>
import { computed } from 'vue';
import CardPriorityIcon from 'dashboard/components-next/Conversation/ConversationCard/CardPriorityIcon.vue';
import IssueHeader from './IssueHeader.vue';

const props = defineProps({
  linkedIssue: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['unlinkIssue']);

const { linkedIssue } = props;

const priorityLabel = computed(() => {
  const priorityMap = {
    urgent: 'Urgent',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
  };
  return priorityMap[linkedIssue.priority];
});

const identifier = computed(() =>
  linkedIssue.sequence_id ? `#${linkedIssue.sequence_id}` : linkedIssue.id
);

const unlinkIssue = () => {
  emit('unlinkIssue', linkedIssue.link_id, linkedIssue.id);
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col w-full">
      <IssueHeader :identifier="identifier" @unlink-issue="unlinkIssue" />

      <h3 class="mt-2 text-sm font-medium text-n-slate-12">
        {{ linkedIssue.title }}
      </h3>
    </div>

    <div class="flex flex-col gap-2">
      <div v-if="priorityLabel" class="flex items-center gap-1.5">
        <CardPriorityIcon :priority="priorityLabel.toLowerCase()" />
        <span class="text-xs text-n-slate-12">
          {{ priorityLabel }}
        </span>
      </div>
    </div>
  </div>
</template>
